import React from 'react';
import { createRoot } from 'react-dom/client';

import { enableMocking } from './configs/enableMocking';

const rootElement = document.getElementById('scheduleMfeRoot');

if (rootElement) {
  const renderApp = (AppComponent: React.ComponentType) => {
    createRoot(rootElement).render(
      <React.StrictMode>
        <AppComponent />
      </React.StrictMode>
    );
  };

  if (import.meta.env.MODE === 'mock') {
    const { AppMock } = await import('./App.mock');
    await enableMocking();
    renderApp(AppMock);
  } else {
    const { default: App } = await import('./App');
    renderApp(App);
  }
}
